module.exports = __webpack_public_path__ + "50a64ae8678e3b9e2afbd780d1a88fbc.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/server-product/images/baoguan.png
// module id = 2470
// module chunks = 31